import React, { useState } from 'react';
import useSetTitle from "../../hooks/useSetTitle";
import { useGetStatsInfoQuery } from '../../store/api/statsApi';
import { DatePicker, Skeleton } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker';
import moment from 'moment';
import style from './Stats.module.scss';
import { 
    CalendarOutlined, 
    FileTextOutlined, 
    CheckCircleOutlined, 
    CloseCircleOutlined, 
    ClockCircleOutlined 
} from '@ant-design/icons';

const { RangePicker } = DatePicker;

const Stats = () => {
    useSetTitle('Статистика аккаунта');
    const [date, setDate] = useState<RangePickerProps['value']>();
    
    const setPreset = (type: 'week' | 'month' | 'year' | 'all') => {
        let start: moment.Moment | undefined = moment();
        let end: moment.Moment | undefined = moment();

        switch (type) {
            case 'week': start = moment().subtract(7, 'days'); break;
            case 'month': start = moment().subtract(30, 'days'); break;
            case 'year': start = moment().subtract(1, 'years'); break;
            case 'all': start = undefined; end = undefined; break;
        }
        
        setDate(start && end ? [start, end] : undefined);
    };

    const { data, isLoading, isFetching } = useGetStatsInfoQuery({
        start: date?.[0]?.format('YYYY-MM-DD'),
        end: date?.[1]?.format('YYYY-MM-DD')
    });

    const statsConfig = [
        { label: "Создано", value: data?.documentsCount, icon: <FileTextOutlined />, type: style.primary },
        { label: "Подписано", value: data?.signed, icon: <CheckCircleOutlined />, type: style.success },
        { label: "Отклонено", value: data?.declined, icon: <CloseCircleOutlined />, type: style.danger },
        { label: "В работе", value: data?.unwatched, icon: <ClockCircleOutlined />, type: style.warning }
    ];

    return (
        <div className={style.container}>
            <div className={style.filterSection}>
                <div className={style.label}><CalendarOutlined /> Период анализа</div>
                
                <div className={style.datePickerWrapper}>
                    <div className={style.presets}>
                        <button className={style.presetBtn} onClick={() => setPreset('week')}>7 дней</button>
                        <button className={style.presetBtn} onClick={() => setPreset('month')}>30 дней</button>
                        <button className={style.presetBtn} onClick={() => setPreset('year')}>Год</button>
                        <button className={style.presetBtn} onClick={() => setPreset('all')}>Всё время</button>
                    </div>
                    
                    <RangePicker 
                        value={date}
                        onChange={(val) => setDate(val)} 
                        separator={<span style={{color: '#94a3b8'}}>→</span>}
                        placeholder={['Начало', 'Конец']}
                    /> 
                </div>
            </div>

            <div className={style.statsGrid}>
                {statsConfig.map((item, index) => (
                    <div key={index} className={`${style.statCard} ${item.type}`}>
                        <div className={style.cardLabel}>{item.label}</div>
                        {(isLoading || isFetching) ? (
                            <Skeleton.Button active style={{ width: 80, height: 40, borderRadius: 8 }} />
                        ) : (
                            <div className={style.cardValue}>{item.value ?? 0}</div>
                        )}
                        <div className={style.iconWrapper}>{item.icon}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Stats;
